import { put, call, takeLatest } from 'redux-saga/effects';


import * as actions from '../actions';
import { AUTH } from '../constants';
import { fetchCaptcha,login } from '../api';
import moment from 'moment';

export default function* watchAccount() {
    yield takeLatest(AUTH.FETCH_CAPTCHA, fetchCaptchaSaga)
    yield takeLatest(AUTH.LOGIN, loginSaga)
}

export function* fetchCaptchaSaga(action) {
    try {
        yield put(actions.fetchCaptchaLoad());
        const [captchaImage] = yield call(fetchCaptcha);
        yield put(actions.fetchCaptchaSuccess(captchaImage));
    } catch (error) {
        console.error(error);
        yield put(actions.fetchCaptchaFail());
    }
}

export function* loginSaga(action) {
    // yield put(actions.loginSuccess('token', { }));
    try {
        yield put(actions.loginLoad());
        const response = yield call(login, action.formData);
        const result = yield response.json();
        
        if(response.status === 200) {
            const token = result.token;
            const user = JSON.stringify(result.user);
            yield put(actions.loginSuccess(token, user));
            // Should reload the page when log in/out; Otherwise JQuery is not functioned.

            window.location.reload();
        
        } else if(response.status === 401) {
            yield put(actions.loginFail("帳號密碼錯誤"));
        
        } else if(response.status === 403) {
            if(result.accountStatus && +result.accountStatus === 0) {
                yield put(actions.loginFail("帳號未啟用"));
            } else if(result.accountStatus && +result.accountStatus === 2) {
                yield put(actions.loginFail("帳號已停用"));
            } else if(result.accountStatus && +result.accountStatus === 3) {
                yield put(actions.loginFail("帳號已上鎖"));
            } else if (result.accountStatus && +result.accountStatus === 4) {
                yield put(actions.loginFail("密碼已過期，請使用忘記密碼功能取得新密碼"));
            } else {
                yield put(actions.loginFail("驗證碼錯誤"));
            }
        } else {
            yield put(actions.loginFail("登入錯誤! Error code: " + response.status));
        }
       
    } catch (error) {
        console.error(error);
        yield put(actions.loginFail("登入錯誤!"));
    }
}